var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61114 2.80542C8.90247 2.80542 9.13892 2.56897 9.13892 2.27764C9.13892 1.98631 8.90247 1.74986 8.61114 1.74986L4.38891 1.74986C4.09758 1.74986 3.86113 1.98631 3.86113 2.27764C3.86113 2.56897 4.09758 2.80542 4.38891 2.80542L8.61114 2.80542Z",
    fill: "#FF3636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50673 11.25C6.64184 11.25 6.76639 11.2046 6.86983 11.1017C7.39761 10.5739 10.5638 7.40723 11.0921 6.87946C11.424 6.54695 11.1992 5.97221 10.729 5.97221L9.14562 5.9722L9.14562 4.38887C9.14562 4.09753 8.90917 3.86109 8.61784 3.86109L4.39561 3.86109C4.10428 3.86109 3.86783 4.09753 3.86783 4.38887L3.86783 5.9722L2.2845 5.9722C1.81425 5.9722 1.57253 6.54695 1.90503 6.87945L6.12726 11.1017C6.2307 11.2046 6.37161 11.25 6.50673 11.25Z",
    fill: "#FF3636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRed);
export default __webpack_public_path__ + "static/media/arrow-down-red.3a091d350e5e77dfbf3411a4c4275bca.svg";
export { ForwardRef as ReactComponent };